const PageContent = props => {
    return (
        <div {...props} className={"kt-page-content " + (props.className || "")}>
            {props.children}
        </div>
    )
}

export default PageContent;